<template>
  <v-card>
    <v-card-title>
      {{ title || $t('booking.edit_recur_confirm_msg') }}
    </v-card-title>
    <v-card-text>
      <v-radio-group v-model="edit">
        <v-radio label="Clear all Selections"
                 value="clear-all"></v-radio>
        <v-radio label="Un-Select Filtered Items"
                 value="unselect"></v-radio>
        <v-radio label="Select all Filtered Items"
                 value="select-all"></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-spacer></v-spacer>
      <v-btn text
             @click="$emit('submit', undefined)">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn text
             color="primary"
             @click="$emit('submit', edit)">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from '@vue/composition-api'

export default {
  name: 'RemotePaginatedListSelectAllDialog',
  props: {
    title: String,
  },
  setup() {
    return {
      edit: ref('select-all'),
    }
  }
}
</script>
